import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getCommercialSaleStatistics, getCommercialReceiveStatistics } from '@/service/production/ProReportShangTong';
export default function useProData(params) {
  var receivingData = ref({
    list: [],
    name: '',
    sumTotal: 0,
    sumWeight: 0
  });
  var saleData = ref([]);
  // 获取商砼原材料采购统计
  var getCommercialReceiveStatisticsAsyc = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return getCommercialReceiveStatistics(params.value);
          case 3:
            data = _context.sent;
            receivingData.value = data;
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function getCommercialReceiveStatisticsAsyc() {
      return _ref.apply(this, arguments);
    };
  }();
  //获取商砼销售统计
  var getCommercialSaleStatisticsAsyc = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return getCommercialSaleStatistics(params.value);
          case 3:
            data = _context2.sent;
            saleData.value = data.list;
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            console.log(_context2.t0);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function getCommercialSaleStatisticsAsyc() {
      return _ref2.apply(this, arguments);
    };
  }();
  return [receivingData, saleData, getCommercialReceiveStatisticsAsyc, getCommercialSaleStatisticsAsyc];
}